<template>
  <el-dialog :close-on-click-modal="false" center :visible.sync="visible" width="672px">
    <div class="state1">
      <dl>
        <dt>
          <img src="~@/assets/img/worning.png"/>
        </dt>
        <dd>
          <h3>注意事项!</h3>
		  <p>1、本中心对客户所送样品或技术资料进行保密。</p>
          <p>2、实验室自行处理的样品，样品保存期限为一个月。</p>
		  <p>3、本中心受理检测质量申诉的有效期最长为15天（自检测报告发出之日算起）。</p>
		  <p>4、检测报告仅对送检样品负责。</p>
        </dd>
      </dl>
    </div>
	<div class="bottom_btns">
      <el-button style="margin-right: 10px;" round @click="visible = false">取消</el-button>
      <el-button type="primary" round @click="submitForm">确认</el-button>
    </div>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				visible:false
			};
		},
		methods: {
			submitForm(){
				this.visible = false;
				this.$emit("comfirmBtn")
			}
		}
	}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
  border-bottom: 0;
}
.bottom_btns{
  padding-top: 43px;
  text-align: right;
  .el-button{
	width: 80px;
	height: 40px;
	font-size: 14px;
  }
}
dd p{
	text-align: left;
}
</style>
